export default {
    init() {
        this.pageRegistrationUpload();
        this.pageRegistrationDragAndDropUpload();
        this.pageRegistrationDeleteUploadFromList();
        this.pageRegistrationDragFromList();
    },

    pageRegistrationUpload(){
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let maxAllowedSize = 16 * 1024 * 1024;
        let wrongFile = $('.fr-registration.inner-page .product-photo-upload-wrap--upload-row .wrong-file-type');
        let uploadArea = $('.fr-registration.inner-page .product-photo-upload-wrap--upload-box');
        let filesList = $('.fr-registration.inner-page .product-photo-upload-wrap--list');
        let importFileInput = $('.fr-registration.inner-page .product-img-file');

        importFileInput.on('change', function () {
            if ($(this)[0].files.length > 0) {
                uploadArea.removeClass('invalid');
                let filesAllowed = [];
                let countInvalid = false;
                let files = $(this)[0].files;

                for (let i = 0; i < files.length; i++) {
                    if(files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else{
                        countInvalid = true;
                    }
                }

                for (let i = 0; i < filesAllowed.length; i++ ) {
                    let numberOfChildren = filesList.children().length;
                    if(numberOfChildren < 30) {
                        filesList.append(`
                        <li class="item">${filesAllowed[i].name}<span data-name="${filesAllowed[i].name}"></span></li>
                    `);
                    }
                }

                if(countInvalid == true ){
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }
            }
        });
    },

    pageRegistrationDragAndDropUpload() {

            const self = this;
            let fileTypes = ['jpg', 'jpeg', 'png'];
            let maxAllowedSize = 16 * 1024 * 1024;
            let wrongFile = $('.fr-registration.inner-page .product-photo-upload-wrap--upload-row .wrong-file-type');
            let uploadArea = $('.fr-registration.inner-page .product-photo-upload-wrap--upload-box');
            let filesList = $('.fr-registration.inner-page .product-photo-upload-wrap--list');
            let explorerCheck = false;
            let safariCheck = false;

            if (navigator.userAgent.indexOf('Trident/') !== -1) {
                explorerCheck = true;
            } else {
                explorerCheck = false;
            }

            if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                safariCheck = true;
            } else {
                safariCheck = false;
            }

            if (!safariCheck && !explorerCheck) {
                // Drag and drop
                window.addEventListener('dragenter', preventDefaults, false);
                window.addEventListener('dragleave', preventDefaults, false);
                window.addEventListener('dragover', preventDefaults, false);
                window.addEventListener('drop', preventDefaults, false);

                window.addEventListener('dragover', highlight, false);
                window.addEventListener('drop', dropFiles, false);
            } else {
            }

            function preventDefaults(e) {
                e.preventDefault();
                e.stopPropagation();
            }

            function highlight() {
                if (!$('.cl-log-in.registration.pop-up').hasClass('active')) {
                    $('.drag-and-drop-toggle.inner-sign-up').show();
                }
            }

            function dropFiles(e) {
                if (!$('.cl-log-in.registration.pop-up').hasClass('active')) {
                    $('.drag-and-drop-toggle.inner-sign-up').hide();


                //If delete previous import
                filesList.empty();

                let filesAllowed = [];
                let files = e.dataTransfer.files;
                let countInvalid = false;

                for (let i = 0; i < files.length; i++) {
                    if (files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else {
                        countInvalid = true;
                    }
                }

                if (countInvalid == true) {
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }

                generateFileList(filesAllowed);
                document.querySelector('.fr-registration.inner-page .product-img-file').files = new FileListItem(filesAllowed);
            }

            function generateFileList(files) {
                for (let file of files) {
                    let numberOfChildren = filesList.children().length;
                    if (numberOfChildren < 30) {
                        filesList.append(`<div class="item">"${file.name}" <span data-name="${file.name}"></span></div>`);
                    }
                }
            }

            function FileListItem(a) {
                a = [].slice.call(Array.isArray(a) ? a : arguments)
                for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
                if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
                for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
                return b.files
            }
            }
    },

    pageRegistrationDeleteUploadFromList() {
        $('body').on('click', '.fr-registration.inner-page .product-photo-upload-wrap--list .item span' ,function () {
            $(this).parent().remove();
        });
    },

    pageRegistrationDragFromList() {
        $('.fr-registration.inner-page .product-photo-upload-wrap--list .item').droppable({
            cursor: 'move',
            greedy: true,
            connectToSortable: ".fr-registration.inner-page .product-photo-upload-wrap--list",
        });
        $('.fr-registration.inner-page .product-photo-upload-wrap--list').sortable({
            revert: true,
        });
    },
}
